/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userProducts.internal

import features.userProducts.models.UserProductsModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class UserProductsRequest : NetworkRequest() {

    suspend fun getUserProducts(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<UserProductsModel> {
        return safeNetworkCall {
            get(
                endpoint = UserProductsEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
